import clsx from 'clsx';
import React, { useRef, useEffect } from 'react';
import ReactPaginate from 'react-paginate';
import { useMedia } from 'react-use';

import { PaginationArrow } from '@srcDS/components/atoms/icons';

import styles from './Pagination.module.scss';

interface PaginationProps {
  handlePageClick: (selectedItem: { selected: number }) => void;
  pageCount: number;
  initialPage: number;
}

const Pagination = ({ handlePageClick, pageCount, initialPage }: PaginationProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const isMobile = useMedia('(max-width: 680px)', false);

  // Need to remove the role attribute from the navigation element to avoid a11y issues
  useEffect(() => {
    ref.current?.querySelector('[role="navigation"]')?.removeAttribute('role');
  }, [ref.current]);

  return (
    <div ref={ref} className={styles.paginationWrapper}>
      <ReactPaginate
        containerClassName={styles.pagination}
        className={styles.pagination}
        pageClassName={styles.pageClassName}
        pageLinkClassName={styles.pageLinkClassName}
        activeClassName={styles.activeClassName}
        previousClassName={styles.pageClassName}
        nextClassName={styles.pageClassName}
        previousLinkClassName={styles.previousLinkClassName}
        nextLinkClassName={styles.nextLinkClassName}
        disabledClassName={clsx(styles.pageClassName, styles.disabledClassName)}
        disabledLinkClassName={styles.disabledLinkClassName}
        breakClassName={clsx(styles.pageClassName, styles.breakClassName)}
        breakLinkClassName={styles.breakLinkClassName}
        breakLabel="..."
        previousLabel={<PaginationArrow direction="left" />}
        nextLabel={<PaginationArrow />}
        pageRangeDisplayed={isMobile ? 2 : 5}
        marginPagesDisplayed={1}
        pageCount={pageCount}
        pageLabelBuilder={(page) => page?.toString().padStart(2, '0')}
        renderOnZeroPageCount={null}
        forcePage={initialPage - 1}
        disableInitialCallback={true}
        onPageChange={(e) => handlePageClick(e)}
      />
    </div>
  );
};

export default Pagination;
